<template>
  <a-form-model
    ref="form"
    :label-col="labelCol"
    :model="form"
    :rules="rules"
    :wrapper-col="wrapperCol"
  >
    <a-form-model-item label="IP 地址范围" style="margin-bottom: 0">
      <div style="display: flex">
        <a-form-model-item prop="ipAddressFrom">
          <a-input v-model="form.ipAddressFrom" :max-length="128" :disabled="true"></a-input>
        </a-form-model-item>
        <span style="margin: 0 4px">~</span>
        <a-form-model-item prop="ipAddressTo">
          <a-input v-model="form.ipAddressTo" :max-length="128" :disabled="true"></a-input>
        </a-form-model-item>
      </div>
    </a-form-model-item>
    <a-form-model-item label="SNMP 端口" prop="port">
      <a-input
        v-model="form.port"
        :max="65535"
        :min="1"
        type="number"
        :disabled="true"
      ></a-input>
    </a-form-model-item>
    <!--    SNMP-->
    <a-form-model-item label="SNMP 版本" prop="snmpVersion">
      <a-select
        v-model="form.snmpVersion"
        :options="options.snmpVersion"
        :disabled="true"
      ></a-select>
    </a-form-model-item>
    <template v-if="form.snmpVersion !== 'snmp_v3'">
      <a-form-model-item
        label="SNMP 团体名"
        prop="snmpCommunity"
        :rules="[
          {
            message: '请输入团体名',
            required: true,
            trigger: 'blur'
          }
        ]"
      >
        <a-input-password
          v-model="form.snmpCommunity"
          :max-length="128"
          :disabled="true"
        ></a-input-password>
      </a-form-model-item>
    </template>
    <template v-else>
      <a-form-model-item label="上下文名称" prop="snmpContextName">
        <a-input v-model="form.snmpContextName" :max-length="128" :disabled="true"></a-input>
      </a-form-model-item>
      <a-form-model-item label="安全名称" prop="snmpSecurityName">
        <a-input v-model="form.snmpSecurityName" :max-length="128" :disabled="true"></a-input>
      </a-form-model-item>
      <a-form-model-item label="安全级别" prop="snmpSecurityLevel">
        <a-select
          v-model="form.snmpSecurityLevel"
          :options="options.snmpSecurityLevel"
          :disabled="true"
        ></a-select>
      </a-form-model-item>

      <template v-if="form.snmpSecurityLevel !== 'no_auth_no_priv'">
        <a-form-model-item label="验证协议" prop="snmpAuthProtocol">
          <a-select
            v-model="form.snmpAuthProtocol"
            :options="options.snmpAuthProtocol"
            :disabled="true"
          ></a-select>
        </a-form-model-item>
        <a-form-model-item label="验证协议密码" prop="snmpAuthPassphrase">
          <a-input-password
            v-model="form.snmpAuthPassphrase"
            :max-length="128"
            :disabled="true"
          ></a-input-password>
        </a-form-model-item>

        <template v-if="form.snmpSecurityLevel === 'auth_priv'">
          <a-form-model-item label="隐私协议" prop="snmpPrivacyProtocol">
            <a-select
              v-model="form.snmpPrivacyProtocol"
              :options="options.snmpPrivacyProtocol"
              :disabled="true"
            ></a-select>
          </a-form-model-item>
          <a-form-model-item
            label="隐私协议密码"
            prop="snmpPrivacyPassphrase"
          >
            <a-input-password
              v-model="form.snmpPrivacyPassphrase"
              :max-length="128"
              :disabled="true"
            ></a-input-password>
          </a-form-model-item>
        </template>
      </template>
    </template>
    <a-form-model-item
      :wrapper-col="{ span: 20, offset: 4 }"
      style="margin-bottom: 0"
    >
      <a-space size="middle">
        <a-button :loading="loading" type="primary" @click="ok" :disabled="true">
          确定
        </a-button>
        <a-button @click="cancel" :disabled="true">取消</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { scanNetworkDevice } from '@/api/network-device'
import { scanServer } from '@/api/server'
import { scanStorage } from '@/api/storage'
import {
  snmpAuthProtocols,
  snmpPrivacyProtocols,
  snmpSecurityLevels,
  snmpVersions
} from '@/utils/const'

export default {
  name: 'ScanForm',
  props: {
    labelCol: {
      type: Object
    },
    sourceType: {
      type: String,
      required: true
    },
    wrapperCol: {
      type: Object
    }
  },
  data () {
    return {
      form: {
        ipAddressFrom: '',
        ipAddressTo: '',
        port: 161,
        snmpVersion: 'snmp_v2c',
        snmpCommunity: 'public',
        snmpContextName: '',
        snmpSecurityName: '',
        snmpSecurityLevel: undefined,
        snmpAuthProtocol: undefined,
        snmpAuthPassphrase: '',
        snmpPrivacyProtocol: undefined,
        snmpPrivacyPassphrase: ''
      },
      rules: {
        ipAddressFrom: [
          {
            message: '请输入起始 IP 地址',
            required: true,
            trigger: 'blur'
          }
        ],
        ipAddressTo: [
          {
            message: '请输入终止 IP 地址',
            required: true,
            trigger: 'blur'
          }
        ],
        port: [
          {
            message: '请输入 SNMP 端口',
            required: true,
            trigger: 'blur'
          }
        ],
        snmpVersion: [
          {
            message: '请选择 SNMP 版本',
            required: true,
            trigger: 'change'
          }
        ]
      },
      options: {
        snmpVersion: snmpVersions.map(value => {
          return {
            title: this.$t(`snmp_version.${value}`),
            value
          }
        }),
        snmpSecurityLevel: snmpSecurityLevels.map(value => {
          return {
            title: this.$t(`snmp_security_level.${value}`),
            value
          }
        }),
        snmpAuthProtocol: snmpAuthProtocols.map(value => {
          return {
            title: this.$t(`snmp_auth_protocol.${value}`),
            value
          }
        }),
        snmpPrivacyProtocol: snmpPrivacyProtocols.map(value => {
          return {
            title: this.$t(`snmp_privacy_protocol.${value}`),
            value
          }
        })
      },
      loading: false
    }
  },
  computed: {
    scanFunc () {
      switch (this.sourceType) {
        case 'network_device':
          return scanNetworkDevice
        case 'storage':
          return scanStorage
        case 'server':
          return scanServer
        default:
          return undefined
      }
    }
  },
  methods: {
    reset () {
      this.form = {
        ipAddressFrom: '',
        ipAddressTo: '',
        port: 161,
        snmpVersion: 'snmp_v2c',
        snmpCommunity: 'public',
        snmpContextName: '',
        snmpSecurityName: '',
        snmpSecurityLevel: undefined,
        snmpAuthProtocol: undefined,
        snmpAuthPassphrase: '',
        snmpPrivacyProtocol: undefined,
        snmpPrivacyPassphrase: ''
      }
      this.$refs.form.resetFields()
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            ip_address_from: this.form.ipAddressFrom,
            ip_address_to: this.form.ipAddressTo,
            port: this.form.port,
            snmp_version: this.form.snmpVersion,
            snmp_community: this.form.snmpCommunity,
            snmp_context_name: this.form.snmpContextName,
            snmp_security_name: this.form.snmpSecurityName,
            snmp_security_level: this.form.snmpSecurityLevel,
            snmp_auth_protocol: this.form.snmpAuthProtocol,
            snmp_auth_passphrase: this.form.snmpAuthPassphrase,
            snmp_privacy_protocol: this.form.snmpPrivacyProtocol,
            snmp_privacy_passphrase: this.form.snmpPrivacyPassphrase
          }
          this.loading = true
          this.scanFunc(params)
            .then(res => {
              this.$message.success(res.message)
              this.reset()
              this.$emit('ok')
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    cancel () {
      this.reset()
      this.$emit('cancel')
    }
  }
}
</script>
